/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brave_Search_HeadingInputs */

const en_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Search`)
};

const id_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Penelusuran`)
};

const ms_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carian Brave`)
};

const ca_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cercador de Brave`)
};

const cs_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyhledávač Brave`)
};

const da_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Søgning`)
};

const de_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Search`)
};

const et_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave'i otsing`)
};

const es_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscador de Brave`)
};

const fr_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche Brave`)
};

const hr_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Tražilica`)
};

const it_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricerca Brave`)
};

const lv_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave meklēšana`)
};

const lt_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Brave“ paieška`)
};

const hu_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave keresés`)
};

const nl_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Search`)
};

const nb_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Søk`)
};

const pl_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Search`)
};

const pt_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisa Brave`)
};

const ro_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Search`)
};

const sk_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyhľadávanie Brave`)
};

const sl_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Iskanje`)
};

const fi_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave-haku`)
};

const sv_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Sök`)
};

const vi_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Tìm kiếm`)
};

const tr_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Arama`)
};

const el_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αναζήτηση Brave`)
};

const bg_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Търсене`)
};

const ru_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave поиск`)
};

const sr_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave претрага`)
};

const uk_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук Brave`)
};

const ka_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave ძებნა`)
};

const hi_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Search`)
};

const th_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Search`)
};

const ko_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave 검색`)
};

const zh_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave 搜索`)
};

const zh_tw_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave 搜尋`)
};

const ja_brave_search_heading = /** @type {(inputs: Brave_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Search`)
};

/**
* | output |
* | --- |
* | "Brave Search" |
*
* @param {Brave_Search_HeadingInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const brave_search_heading = /** @type {((inputs?: Brave_Search_HeadingInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brave_Search_HeadingInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_brave_search_heading(inputs)
	if (locale === "ms") return ms_brave_search_heading(inputs)
	if (locale === "ca") return ca_brave_search_heading(inputs)
	if (locale === "cs") return cs_brave_search_heading(inputs)
	if (locale === "da") return da_brave_search_heading(inputs)
	if (locale === "de") return de_brave_search_heading(inputs)
	if (locale === "et") return et_brave_search_heading(inputs)
	if (locale === "es") return es_brave_search_heading(inputs)
	if (locale === "fr") return fr_brave_search_heading(inputs)
	if (locale === "hr") return hr_brave_search_heading(inputs)
	if (locale === "it") return it_brave_search_heading(inputs)
	if (locale === "lv") return lv_brave_search_heading(inputs)
	if (locale === "lt") return lt_brave_search_heading(inputs)
	if (locale === "hu") return hu_brave_search_heading(inputs)
	if (locale === "nl") return nl_brave_search_heading(inputs)
	if (locale === "nb") return nb_brave_search_heading(inputs)
	if (locale === "pl") return pl_brave_search_heading(inputs)
	if (locale === "pt") return pt_brave_search_heading(inputs)
	if (locale === "ro") return ro_brave_search_heading(inputs)
	if (locale === "sk") return sk_brave_search_heading(inputs)
	if (locale === "sl") return sl_brave_search_heading(inputs)
	if (locale === "fi") return fi_brave_search_heading(inputs)
	if (locale === "sv") return sv_brave_search_heading(inputs)
	if (locale === "vi") return vi_brave_search_heading(inputs)
	if (locale === "tr") return tr_brave_search_heading(inputs)
	if (locale === "el") return el_brave_search_heading(inputs)
	if (locale === "bg") return bg_brave_search_heading(inputs)
	if (locale === "ru") return ru_brave_search_heading(inputs)
	if (locale === "sr") return sr_brave_search_heading(inputs)
	if (locale === "uk") return uk_brave_search_heading(inputs)
	if (locale === "ka") return ka_brave_search_heading(inputs)
	if (locale === "hi") return hi_brave_search_heading(inputs)
	if (locale === "th") return th_brave_search_heading(inputs)
	if (locale === "ko") return ko_brave_search_heading(inputs)
	if (locale === "zh") return zh_brave_search_heading(inputs)
	if (locale === "zh-tw") return zh_tw_brave_search_heading(inputs)
	if (locale === "ja") return ja_brave_search_heading(inputs)
	return en_brave_search_heading(inputs)
});